export default {
  'dorothy': {
    type: 'sub',
    name: 'ドロシー',
    fukidashi: '「次やったら、ブタ箱行きだからね」',
    description: 'ローランをコンゲームの世界に誘った自称天才コンフィデンスレディ。上海龍虎幇とのゲームに敗れたあと行方が分からなくなっていた。現在は過去の記憶を無くし、台湾の海辺の町に住む老夫婦の養子として過ごしている。',
    cv: '小松由佳',
    image: '/assets/images/character-raz-dorothy.jpg'
  },
  'jei': {
    type: 'sub',
    name: '江 品爵（ジェイ）',
    fukidashi: '「俺の命の恩人なんだよ」',
    description: '台北の黒社会に君臨する王（ワン）の組織の若頭。女好きな遊び人で、組織の集まりはズル休みの常習犯。楊とは腐れ縁。',
    cv: '武内駿輔',
    image: '/assets/images/character-raz-jei.jpg'
  },
  'ai': {
    type: 'sub',
    name: '楊 崑義（アイ）',
    fukidashi: '「見返りは高くつくぜ」',
    description: '自称“台北一の天才詐欺師”。ドロシーに詐欺を仕掛けるも返り討ちに遭う。身なりに無頓着で金に卑しいが、どこかお人好しで憎めない。',
    cv: '間宮康弘',
    image: '/assets/images/character-raz-ai.jpg'
  },
  'lin': {
    type: 'sub',
    name: '林',
    fukidashi: '「隠れてこそこそやるからには、 それなりにおいしいものを、ねえ？」',
    description: '王の組織の所属員で、ジェイの弟分。上昇志向が強く、組織内で狡猾に動き回る。',
    cv: '興津和幸',
    image: '/assets/images/character-raz-lin.jpg'
  },
  'wan': {
    type: 'sub',
    name: '王 翊碁',
    fukidashi: '「手綱はちゃんと握っておけ」',
    description: '台北の黒社会を牛耳る冷徹な男。若頭の江に目をかけている。',
    cv: '加瀬康之',
    image: '/assets/images/character-raz-wan.jpg'
  },
  'sai': {
    type: 'sub',
    name: '蔡',
    fukidashi: '「気を付けなよぉ？ 女に執着すると足元掬われるからさ」',
    description: '王の組織の幹部であり、右腕。“ドラッグソムリエ”の異名を持つ。',
    cv: 'かぬか光明',
    image: '/assets/images/character-raz-sai.jpg'
  },
  'bin': {
    type: 'sub',
    name: 'ビンイェン',
    fukidashi: '「すみません、守秘義務がありまして」',
    description: '寡黙でポーカーフェイスな王の秘書。最近までジェイと付き合っていたようだが…',
    cv: '伊瀬茉莉也',
    image: '/assets/images/character-raz-bin.jpg'
  },
  index: {
    main: [
      {
        id: 'dorothy',
        icon: '/assets/images/character-raz-dorothy-icon.png'
      },
      {
        id: 'jei',
        icon: '/assets/images/character-raz-jei-icon.png'
      },
      {
        id: 'ai',
        icon: '/assets/images/character-raz-ai-icon.png'
      },
      {
        id: 'lin',
        icon: '/assets/images/character-raz-lin-icon.png'
      },
      {
        id: 'wan',
        icon: '/assets/images/character-raz-wan-icon.png'
      },
      {
        id: 'sai',
        icon: '/assets/images/character-raz-sai-icon.png'
      },
      {
        id: 'bin',
        icon: '/assets/images/character-raz-bin-icon.png'
      }
    ],
    case: []
  }
}



// WEBPACK FOOTER //
// ./src/data/razbliuto/character.js